import type { ModelPreset, ModelPresetBody } from "@/schemas/model-preset.schema";
import { api } from "@/services/api";

export const modelPresetApi = {
  async create(body: ModelPresetBody) {
    const { data } = await api.post("/model-presets", body);

    return data as ModelPreset;
  },

  async updateById(id: string, body: ModelPresetBody) {
    const { data } = await api.patch(`/model-presets/${id}`, body);

    return data as ModelPreset;
  },

  async deleteById(id: string) {
    await api.delete(`/model-presets/${id}`);
  },
};
